// Development environment configuration
export const environment = {
  production: false,
  environmentName: 'development',
  /** Local admin password reset (run: npm run dev:reset-server) */
  adminResetPasswordUrl: 'http://localhost:5050/reset-password',
  firebase: {
    apiKey: 'AIzaSyARh7IJBpZ8xoIiGTEqctkSfflP2aXtBbs',
    authDomain: 'ppms-dev-9361e.firebaseapp.com',
    projectId: 'ppms-dev-9361e',
    storageBucket: 'ppms-dev-9361e.firebasestorage.app',
    messagingSenderId: '578579666497',
    appId: '1:578579666497:web:4ccfb169dde3c3a97918c0',
  },
};
